import React, { createContext, useContext } from 'react';

const Context = createContext();

export const useAllowClearClassicTime = () => useContext(Context);

export const AllowClearClassicTimeProvider = ({
  allowClear = false,
  children,
}) => {
  return <Context.Provider value={allowClear}>{children}</Context.Provider>;
};
